import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Page error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'calc(100vh - 60px)',
          background: '#F4F6F8',
          gap: '12px',
          fontFamily: 'Segoe UI, sans-serif',
        }}>
          <div style={{ fontSize: '2.5rem' }}>⚠️</div>
          <h2 style={{ color: '#16202C', fontSize: '1.4rem', margin: 0 }}>
            Something went wrong
          </h2>
          <p style={{ color: '#5A6A7A', fontSize: '0.9rem', margin: 0 }}>
            This page encountered an error. The rest of the app is unaffected.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{
              marginTop: '8px',
              padding: '8px 20px',
              background: 'linear-gradient(135deg, #1E3A5F, #0F766E)',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '700',
              fontSize: '0.9rem',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
